import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { ThreatResponse } from "app/core/models/threat-response";

@Injectable()
export class ThreatService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getThreats(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<ThreatResponse> {
    
    const allStringFilterAux = [];
    activeFilters.forEach((item) => {
        if (item['value'] != null && item['value'] != '') {
            const stringFilterAux = [item['id'],item['value']];
            allStringFilterAux.push(stringFilterAux.join('::'));
        }
    });

    const queryFilter = allStringFilterAux.join('--');

    
    const params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/ewan/threats`, {
      params: params
      }).pipe(
          
          map(res =>  <ThreatResponse>res)
      );    
    
  }

  getThreatStatus(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/ewan/threats/status`);
  }

  getThreatLevels(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/ewan/threats/levels`);
  }

  getThreat(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/ewan/threats/${id}`);
  }

  editThreat(Threat, id: string): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/ewan/threats/${id}`, Threat);
  }

  createThreat(threat: any): Observable < any > {
      return this._httpClient.post(`${environment.apiUrl}/ewan/threats`, threat);
  }

  deleteThreat(id: string): Observable < any > {
      return this._httpClient.delete(`${environment.apiUrl}/ewan/threats/${id}`);
  }  
}
